export default __webpack_public_path__ + "f3d5ad5ae8490a14e49ce5400498e724.png";